export default {
  development: {
    api: "http://192.168.122.132:8013",
    loginHost: 'http://172.16.5.211:8022',
    static: "/"
  },
  dev: {
    api: "https://dev-gateway.ywwl.com",
    loginHost: 'http://172.16.5.211:8022',
    static: "/"
  },
  test: {
    api: "https://test-gateway.ywwl.com",
    loginHost: 'http://172.16.5.175:8022',
    static: "/"
  },
  prod: {
    api: "https://gateway.ywwl.com",
    loginHost: 'http://oper.98u.com',
    static: "/"
  }
}
